export enum ColorTypeEnum {
  primary = 1,
  secondary = 2,
  warning = 3
}
